import type { AppRoute } from 'src/routes/types';

// @mui
import { Box, Stack } from '@mui/material';

import Logo from '../../../components/logo';
import { NavSectionMini } from '../../../components/nav-section';
import { NAV } from '../../../config-global';
import { hideScrollbarX } from '../../../utils/cssStyles';
import navConfig from './config-navigation';
import NavToggleButton from './NavToggleButton';

// config
// utils
// components
//
type NavMiniProps = {
  privateAppRoutes: AppRoute[];
};

const NavMini = ({ privateAppRoutes }: NavMiniProps) => {
  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          left: NAV.W_DASHBOARD_MINI - 12,
          top: 22,
        }}
      />

      <Stack
        sx={{
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          height: 1,
          pb: 2,
          position: 'fixed',
          width: NAV.W_DASHBOARD_MINI,
          ...hideScrollbarX,
        }}
      >
        <Logo isMini sx={{ height: 40, mx: 'auto', my: 2, width: 40 }} />

        <NavSectionMini data={navConfig(privateAppRoutes)} />
      </Stack>
    </Box>
  );
};

export default NavMini;
